import React, { useEffect, useState } from 'react';
import { useLoading } from '../../../commons/Loading';
import { useAlert } from 'react-alert';
import { useAuth } from '../../../commons/Auth';
import { useTranslation } from 'react-i18next';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import { useDebouncedCallback } from 'use-debounce';
import {
  createBonus,
  getReportsVariableRevenuesSignals,
} from '../../../lib/fetch/reports';
import VarRevSignalsDetailPresentational from './VarRevSignalsDetailPresentational';
import { withRouter } from 'react-router-dom';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const VarRevSignalsDetail = (props) => {
  const { profile = {} } = props;
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();
  const [{ newToken } = {}] = useAuth();
  const [t] = useTranslation('SIGNALS');

  const { _id: profileId } = profile;
  const [reports, setReports] = useState({
    categories: { gnet_admin: {}, supplier: {}, bonuses: { data: [] } },
    totals: {},
  });

  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    admin: withDefault(StringParam, ''),
    signalman: withDefault(StringParam, ''),
    condo: withDefault(StringParam, ''),
    year: withDefault(
      NumberParam,
      props.query?.year || new Date().getFullYear()
    ),
    accountabilityMonth: NumberParam,
    signalTypeCode: withDefault(StringParam, 'CONDO'),
    notes: withDefault(StringParam, ''),
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
  });

  const {
    admin,
    signalman,
    condo,
    year,
    accountabilityMonth,
    signalTypeCode,
    limit,
    offset,
    notes,
  } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.signalTypeCode &&
        queryDiff.signalTypeCode !== signalTypeCode) ||
      (signalTypeCode && queryDiff.signalTypeCode === '') ||
      (queryDiff.admin && queryDiff.admin !== admin) ||
      (admin && queryDiff.admin === '') ||
      (queryDiff.notes && queryDiff.notes !== notes) ||
      (notes && queryDiff.notes === '') ||
      (queryDiff.condo && queryDiff.condo !== condo) ||
      (condo && queryDiff.condo === '') ||
      (queryDiff.signalman && queryDiff.signalman !== signalman) ||
      (signalman && queryDiff.signalman === '') ||
      (queryDiff.accountabilityMonth &&
        queryDiff.accountabilityMonth !== accountabilityMonth) ||
      (accountabilityMonth && queryDiff.accountabilityMonth === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const [fetchReportsSignals] = useDebouncedCallback(async () => {
    showLoading();
    const response = await getReportsVariableRevenuesSignals({
      admin,
      signalman,
      condo,
      year,
      accountabilityMonth,
      signalTypeCode,
      limit,
      offset,
      newToken,
      profileId,
      notes,
    });

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;
    setReports(data);
    setTotal(data.categories?.variableRevenuesSignals?.count);
  }, 1000);

  async function onAddBonus(bonus) {
    const { error } = await createBonus({
      newToken,
      bonus: { ...bonus, profileId },
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      hideLoading();
      return;
    }
  }

  useEffect(() => {
    fetchReportsSignals();
  }, [
    admin,
    signalman,
    condo,
    year,
    accountabilityMonth,
    signalTypeCode,
    limit,
    offset,
    notes,
  ]);

  return (
    <VarRevSignalsDetailPresentational
      data={reports}
      onAddBonus={onAddBonus}
      onFilter={onFilter}
      query={query}
      total={total}
      profileType={profile.type}
      setQuery={setQuery}
      fetchReportsSignals={fetchReportsSignals}
      profileId={profileId}
      {...props}
    />
  );
};

export default withRouter(VarRevSignalsDetail);
